import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { logout } from 'domains/Auth';
import dashboardService from '../../services';
import { initialState } from '../constants';

export const forwardConfirmationEmailAction = createAsyncThunk(
  'dashboard/forwardConfirmationEmailAction',
  dashboardService.forwardConfirmationEmail,
);

export const checkCloudflareDismissAction = createAsyncThunk(
  'dashboard/checkCloudflareDismissAction',
  dashboardService.checkCloudflareDismiss,
);

const usersSlice = createSlice({
  name: 'usersSlice',
  initialState: initialState.users,
  reducers: {
    cleanForwardConfirmationEmail(state) {
      state.forwardConfirmationEmail =
        initialState.users.forwardConfirmationEmail;
      return state;
    },
    cleanCloudflareDismissCheck(state) {
      state.cloudflareDismissCheck = initialState.users.cloudflareDismissCheck;
      return state;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(logout.fulfilled, (state) => {
      state = initialState.users;
      return state;
    });

    builder
      .addCase(forwardConfirmationEmailAction.pending, (state) => {
        state.forwardConfirmationEmail.status = 'loading';
      })
      .addCase(forwardConfirmationEmailAction.rejected, (state) => {
        state.forwardConfirmationEmail.status = 'error';
      })
      .addCase(forwardConfirmationEmailAction.fulfilled, (state) => {
        state.forwardConfirmationEmail.status = 'success';
      });

    builder
      .addCase(checkCloudflareDismissAction.pending, (state) => {
        state.cloudflareDismissCheck.status = 'loading';
      })
      .addCase(checkCloudflareDismissAction.rejected, (state) => {
        state.cloudflareDismissCheck.status = 'error';
      })
      .addCase(checkCloudflareDismissAction.fulfilled, (state, action) => {
        state.cloudflareDismissCheck.status = 'success';
        state.cloudflareDismissCheck.data = action.payload;
      });
  },
});

export const { reducer } = usersSlice;
export const { cleanForwardConfirmationEmail, cleanCloudflareDismissCheck } =
  usersSlice.actions;
